import api from "@/lib/api";

const SW_PATH = "/sw.js";

export const pushSupported = () =>
  window.isSecureContext && "serviceWorker" in navigator &&
  "PushManager" in window && "Notification" in window;

const toBytes = value => {
  const padded = (value + "=".repeat((4 - value.length % 4) % 4))
    .replace(/-/g, "+").replace(/_/g, "/");
  return Uint8Array.from(atob(padded), char => char.charCodeAt(0));
};

export async function existingPushSubscription() {
  if (!pushSupported()) return null;
  const registration = await navigator.serviceWorker.getRegistration(SW_PATH);
  return registration?.pushManager.getSubscription() || null;
}

export async function enableSupportPush() {
  if (!pushSupported()) throw new Error("Questo browser non supporta le notifiche push.");
  if (Notification.permission === "denied") throw new Error("Le notifiche sono bloccate nelle impostazioni del browser.");
  const { data } = await api.get("/support/push/public-key");
  const registration = await navigator.serviceWorker.register(SW_PATH, { scope: "/" });
  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") throw new Error("Permesso notifiche non concesso.");
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true, applicationServerKey: toBytes(data.publicKey),
    });
  }
  try {
    await api.post("/support/push/subscriptions", subscription.toJSON());
  } catch (error) {
    await subscription.unsubscribe();
    throw error;
  }
  return subscription;
}

export async function disableSupportPush() {
  const subscription = await existingPushSubscription();
  if (!subscription) return;
  await api.delete("/support/push/subscriptions", { data: subscription.toJSON() });
  await subscription.unsubscribe();
}

export async function rebindExistingPush() {
  const subscription = await existingPushSubscription();
  if (subscription) await api.post("/support/push/subscriptions", subscription.toJSON());
}